import type { ReactNode } from 'react';
import React from 'react';

import { Box, List, ListItem, ListItemText } from '@mui/material';

import useUserDetails from '@/hooks/useUserDetails';

const ExportPreviewScreen = ({
  bulletPoints,
  children,
  listFooter
}: {
  actionHeading: string | undefined;
  bulletPoints: never[] | string[] | undefined;
  children?: ReactNode;
  handlePrimaryButtonClick?: () => void;
  primaryButtonLabel?: string;
  secondaryButton?: ReactNode;
  listFooter?: ReactNode;
}) => {
  const { isUserPremium, isUserExpired } = useUserDetails();

  const content = !isUserPremium || isUserExpired ? null : children;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      {bulletPoints && bulletPoints?.length > 0 && (
        <List
          sx={theme => ({
            p: 0,
            ml: 1,
            '.MuiListItemText-root': {
              m: 0
            },
            '.MuiTypography-root': {
              fontSize: theme.typography.pxToRem(14),
              lineHeight: '28px'
            },
            '.MuiListItem-root': { p: 0, alignItems: 'center' },
            '.MuiButtonBase-root': {
              m: 0,
              fontSize: theme.typography.pxToRem(14)
            }
          })}
        >
          {bulletPoints?.map((option: string) => (
            <ListItem key={option}>
              <Box sx={{ backgroundColor: 'text.primary', width: 4, height: 4, mr: 1 }} />
              <ListItemText primary={option} />
            </ListItem>
          ))}
          {listFooter && (
            <ListItem>
              <Box sx={{ backgroundColor: 'text.primary', width: 4, height: 4, mr: 1 }} />
              <ListItemText primary={listFooter} />
            </ListItem>
          )}
        </List>
      )}

      {content}
    </Box>
  );
};
export default ExportPreviewScreen;
